export default __webpack_public_path__ + "static/media/edit-pen.55c0bcf9.svg";